/* eslint semi:0 */
/**
 * Initializes post page specific modules.
 */
import './bootstrap_common'
import { queryString } from '../utils/window'
import initTopPosts from '../organizedByType/initializers/initTopPosts'
import initBrowsi from '../organizedByType/initializers/initBrowsi'
import initScreenClassifer from '../organizedByType/initializers/deviceScreenClassifier'
import initPageTemplateClassifier from '../organizedByType/initializers/pageTemplateClassifier'
import initAnalytics from '../organizedByType/initializers/analyticsInitializer'
import '../organizedByType/initializers/analyticsScrollEventInitializer'
import initDocumentBodyClassSetter from '../organizedByType/initializers/documentBodyClassSetter'
import initTaboola from '../organizedByType/initializers/taboolaInitializer'
import '../organizedByType/initializers/providersInitializer'
import initLocaleCookieInitializer from '../organizedByType/initializers/localeCookieInitializer'
import mountFantasyComponent from '../../components/fantasy/fantasyMounter'
import mountFacebookBot from '../../components/facebook_bot/facebookBotMounter'
import initGoogleAds from '../organizedByType/initializers/ads/initGoogleAds'

const { noThirdParty } = queryString

function initInitializers() {
  initScreenClassifer()
  initPageTemplateClassifier()
  initTopPosts()
  initAnalytics()
  initDocumentBodyClassSetter()
  initLocaleCookieInitializer()
}

function initThirdParty() {
  initGoogleAds()
  initTaboola()
  initBrowsi()
  mountFantasyComponent()
  mountFacebookBot()
}

function init() {
  initInitializers()
  if (!noThirdParty) {
    initThirdParty()
  }
}

init()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/bootstrap_post_page.js